const { produce } = require("immer");

const init = {
  profileUid: null
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_validateForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
        if(action.form.profile) draft.profileUid = action.form.profile;
      });

    case "UPDATE_validateForm":
      return produce(state, draft => {
        Object.assign(draft, action.form);
      });

    case "RESET_validateForm":
      return init;

    default:
      return state;
  }
}
